import React from 'react';
import TableContents from '../types/TableContents';
import { DOCS_RIGHT_SIDE_MENU_TABLE_CONTENT } from '../constants/constants';
import useTrackingRightNavInView from '../utils/useTrackingRightNavInView';
import { useHistory } from 'react-router';
import RightSideMenuSectionComponent from '../components/RightSideMenuSectionComponent';

const RightSideMenuContainer : React.FunctionComponent = (): JSX.Element =>
{
    // Get current path name
    const history = useHistory();
    const currentPathName: string = history.location.pathname;

    // Get Table Contents based on the current path name
    const tableContents: TableContents | undefined = DOCS_RIGHT_SIDE_MENU_TABLE_CONTENT.find( tableContent =>
    {
        return tableContent.pathName.includes( currentPathName )
    } );

    // useTrackingRightNavInView will figure out where we are in the document and highlight the navbar accordingly
    const [ rightNavInView ] = useTrackingRightNavInView( currentPathName, tableContents );

    return (
        <>
            {
                tableContents && tableContents.rightMenuNavs &&
                <RightSideMenuSectionComponent tableContents={tableContents} history={history}
                                               rightNavInView={rightNavInView}/>
            }
        </>
    )
}

export default RightSideMenuContainer;
